import React, { useRef } from 'react'
import {animate, motion} from "framer-motion"
import Typewriter from 'typewriter-effect'
import {BsArrowUpRight, BsChevronDown} from 'react-icons/bs'
import me from "../assets/logo5.png"

const Home = ( ) => {
    const clientCount = useRef(null)
    const projectCount = useRef(null)   

    // te 0 to 10 ch count
    const animationClientsCount =()=>{
        animate(0,10,{
            duration:1,
            onUpdate:(v)=>(clientCount.current.textContent = v.toFixed())
        })
    }

    // te 0 t0 30 ch count
    const animationProjectsCount =()=>{
        animate(0,30,{
            duration:1,
            onUpdate:(v)=>(projectCount.current.textContent = v.toFixed())
        })
    }

    // te word yayle ki typing ch te
    const animations ={
        h1:{
            initial:{
                x:"-100%",
                opacity:0,
            },
            whileInView:{
                x:0,
                opacity:1,
            }
        },
        button:{
            initial:{
                y:"-100%",
                opacity:0,
            },
            whileInView:{
                y:0,
                opacity:1,
            }
        }
    }
    
  return (
    <div id='home'>
        <section>
            <div>
                <motion.h1 {...animations.h1}>
                    Hi, I am ,<br/> Pavan Kamthane
                </motion.h1>

                <Typewriter options={
                    {
                        strings:["Web Developer","Frontend Developer","Backend Developer","Full Stack Developer"],
                        autoStart:true,
                        loop:true,
                        cursor:"",
                        wrapperClassName:"typewriterpara"
                    }
                }/>

                <div>
                        <a href="mailto:pavankamthane4@gmail.com">Hire Me</a>
                        <a href="#work">Projects <BsArrowUpRight/></a>
                </div>


                <article>
                    <p>
                        +<motion.span whileInView={animationClientsCount} ref={clientCount}></motion.span>
                    </p>
                    
                    <span>
                        Happy Clients
                    </span>
                </article>

                <aside>
                    <article>
                        <p>
                            +<motion.span
                                whileInView={animationProjectsCount}
                                ref={projectCount}
                            >
                            </motion.span>
                        </p>
                        
                        <span>
                            Projects Done
                        </span>
                    </article>

                    <article data-special>
                        <p>Contact</p>
                        <span>pavankamthane4@gmail.com</span>
                    </article>
                </aside>
            </div>
        </section>
        <section>
            <img src={me} alt="Pavan" />
        </section>
        <BsChevronDown/>
    </div>
  )
}

export default Home